import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { ALL, ARCHIVED, COMPLETED, ONGOING } from "constants/task";

export const StatusTab = ({
  setStatus,
  status,
}: {
  setStatus: (v: string) => void;
  status: string;
}) => {
  return (
    <div>
      <ToggleGroup
        value={status}
        onValueChange={(value) => {
          setStatus(value);
        }}
      >
        <ToggleGroupItem value={ALL}>All</ToggleGroupItem>
        <ToggleGroupItem value={ONGOING}>Ongoing</ToggleGroupItem>
        <ToggleGroupItem value={COMPLETED}>Completed</ToggleGroupItem>
        <ToggleGroupItem value={ARCHIVED}>Archived</ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
